import type { MessageInstance } from 'antd/es/message/interface'
import type { NotificationInstance } from 'antd/es/notification/interface'

// Global notification and message instances
let notificationInstance: NotificationInstance | null = null
let messageInstance: MessageInstance | null = null

export const setNotificationInstance = (instance: NotificationInstance) => {
  notificationInstance = instance
}

export const setMessageInstance = (instance: MessageInstance) => {
  messageInstance = instance
}

export const showNotification = {
  success: (message: string, description?: string) => {
    notificationInstance?.success({
      title: message,
      description,
      placement: 'topRight',
    })
  },
  error: (message: string, description?: string) => {
    notificationInstance?.error({
      title: message,
      description,
      placement: 'topRight',
    })
  },
  warning: (message: string, description?: string) => {
    notificationInstance?.warning({
      title: message,
      description,
      placement: 'topRight',
    })
  },
  info: (message: string, description?: string) => {
    notificationInstance?.info({
      title: message,
      description,
      placement: 'topRight',
    })
  },
}

export const showMessage = {
  success: (content: string) => messageInstance?.success(content),
  error: (content: string) => messageInstance?.error(content),
  warning: (content: string) => messageInstance?.warning(content),
  info: (content: string) => messageInstance?.info(content),
  loading: (content: string) => messageInstance?.loading(content),
}
